const S = '@charset "UTF-8";:host{display:block;font-family:var(--schema-font-family, ui-sans-serif, system-ui, -apple-system);color:var(--schema-color-fg, #111827)}*,*:before,*:after{box-sizing:border-box}.wrapper{display:block;background:var(--schema-color-bg, #ffffff)}.form{display:grid;gap:12px}.field{display:grid;gap:6px;padding:8px 10px;border:1px solid var(--schema-color-muted, #e5e7eb);border-radius:var(--schema-radius, 10px);background:var(--schema-surface, #fff)}.label{font-size:12px;color:var(--schema-color-muted-text, #6b7280)}.input,select,textarea{width:100%;padding:8px 10px;border-radius:8px;border:1px solid var(--schema-color-muted, #e5e7eb);background:var(--schema-input-bg, #fff);color:inherit}.checkbox{display:inline-flex;align-items:center;gap:8px}.helper{font-size:12px;color:var(--schema-color-muted-text, #6b7280)}.row{display:grid;gap:8px}.actions{display:flex;gap:8px}.btn{padding:6px 10px;border:1px solid var(--schema-color-muted, #e5e7eb);background:var(--schema-btn-bg, #f8fafc);border-radius:8px;cursor:pointer;color:var(--schema-color-fg)}.btn.primary{background:var(--schema-color-primary, #2563eb);color:#fff;border-color:transparent}.btn:disabled{opacity:.5;cursor:not-allowed}.btn.danger{background:var(--schema-color-danger, #dc2626);color:#fff;border-color:transparent}.group{display:grid;gap:10px}.kv{display:grid;grid-template-columns:1fr 1fr auto;gap:8px;align-items:center}.badge{display:inline-flex;padding:2px 6px;border-radius:999px;font-size:11px;background:var(--schema-badge-bg, #eef2ff);color:var(--schema-badge-fg, #4f46e5)}.hidden{display:none!important}.toolbar{display:flex;gap:6px}.schema-collection-row{position:relative;transition:transform var(--schema-collection-transition-duration, .25s) var(--schema-collection-transition-ease, ease),opacity var(--schema-collection-transition-duration, .25s) var(--schema-collection-transition-ease, ease)}.schema-collection-row.enter{opacity:0}.schema-collection-row.enter.enter-active{opacity:1}.schema-collection-row.leaving{opacity:0}.field.schema-type-array .group,.field.schema-type-array .group .row{position:relative}', z = {
  arrayAdd: "+",
  arrayMoveUp: "↑",
  arrayMoveDown: "↓",
  arrayRemove: "×",
  dictAdd: "+",
  dictRemove: "×",
  rootLabel: "root"
}, b = (r, n) => {
  customElements.get(r) || customElements.define(r, n);
}, ae = (r, n, s) => {
  if (!n.length) return;
  let e = r, t = null, i = null;
  for (let o = 0; o < n.length - 1; o++) {
    const c = n[o];
    let l = e?.[c];
    l == null ? (l = typeof n[o + 1] == "number" ? [] : {}, e[c] = l) : typeof l != "object" && (l = typeof n[o + 1] == "number" ? [] : {}, e[c] = l), t = e, i = c, e = l;
  }
  const a = n[n.length - 1];
  if (e == null || typeof e != "object") {
    const o = typeof a == "number" ? [] : {};
    if (t)
      t[i] = o, e = o;
    else
      return;
  }
  try {
    e[a] = s;
  } catch {
    try {
      const c = Array.isArray(e) ? e.slice() : { ...e };
      c[a] = s, t && (t[i] = c);
    } catch {
    }
  }
}, D = (r) => r.map(String).join("."), re = (r) => r.replace(/[^a-zA-Z0-9_-]/g, "_"), A = (r) => `schema_${re(D(r) || "root")}`, k = (r) => D(r), m = (r, ...n) => {
  const s = new Set(n);
  s.size && r.setAttribute("part", Array.from(s).join(" "));
}, oe = [
  "wrapper",
  "form",
  "field",
  "field-intersect",
  "field-string",
  "field-number",
  "field-boolean",
  "field-date",
  "field-const",
  "field-array",
  "field-object",
  "field-tuple",
  "field-union",
  "field-dict",
  "field-label",
  "field-helper",
  "field-group",
  "field-row",
  "field-actions",
  "field-button",
  "field-button-primary",
  "field-button-danger",
  "field-button-secondary",
  "field-toolbar",
  "field-badge",
  "field-input",
  "field-input-text",
  "field-input-number",
  "field-input-date",
  "field-input-select",
  "field-input-textarea",
  "field-input-checkbox",
  "field-const-value",
  "collection-row",
  "field-checkbox",
  "field-checkbox-text",
  "field-toolbar-select"
].join(" ");
function O(r, n) {
  if (n == null) return n;
  switch (r) {
    case "number":
    case "natural":
    case "percent": {
      if (n === "") return;
      const s = Number(n);
      return Number.isNaN(s) ? void 0 : s;
    }
    case "boolean":
      return !!n;
    case "date": {
      if (!n) return;
      const s = new Date(n);
      return Number.isNaN(+s) ? void 0 : s;
    }
    default:
      return n;
  }
}
function U(r) {
  return typeof r == "function" && !!r?.type;
}
function V(r) {
  if (!r) throw new Error("schema is required");
  if (U(r)) return r;
  try {
    const n = Schema.from(r);
    if (U(n)) return n;
  } catch {
  }
  if (r?.type) {
    const n = r.type;
    if (Schema[n]) return Schema[n](r.inner ?? r.list ?? r.dict);
  }
  throw new Error("无法从传入对象生成 Schemastery 实例，请传入 schema 或 schema.toJSON() 的结果。");
}
function L(r) {
  return r?.meta ?? {};
}
function ce(r) {
  return r.length > 0 && r.every((n) => n?.type === "const");
}
function T(r) {
  if (!r) return;
  const n = r, s = n.meta || {};
  if (Object.prototype.hasOwnProperty.call(s, "default")) return s.default;
  const e = n.type;
  try {
    const t = r();
    if (t !== void 0) return t;
  } catch {
  }
  switch (e) {
    case "string":
      return "";
    case "number":
    case "natural":
    case "percent":
      return 0;
    case "boolean":
      return !1;
    case "array":
      return [];
    case "tuple":
      return [];
    case "object":
      return {};
    case "dict":
      return {};
    case "union": {
      const t = n.list || [];
      return t.length ? T(t[0]) : void 0;
    }
    case "const":
      return n.value;
    case "date":
      return;
    case "intersect": {
      const t = n.list || [], i = (o, c) => {
        if (Array.isArray(o) && Array.isArray(c)) return c.slice();
        if (o && c && typeof o == "object" && typeof c == "object") {
          const l = { ...o };
          for (const d of Object.keys(c))
            l[d] = d in l ? i(l[d], c[d]) : c[d];
          return l;
        }
        return c ?? o;
      };
      let a = {};
      for (const o of t) a = i(a, T(o));
      return a;
    }
    default:
      return;
  }
}
class w extends HTMLElement {
  constructor() {
    super(), this._path = [], this._i18n = z, this.$root = this.attachShadow({ mode: "open" });
    const n = document.createElement("style");
    n.textContent = S, this.$root.appendChild(n);
  }
  /** 初始化公共容器（带类名与 data-path） */
  makeFieldContainer(n, s) {
    const e = document.createElement("div");
    if (e.className = `field schema-form-item schema-type-${n}`, e.setAttribute("data-path", D(this._path)), m(e, "field", `field-${n}`), this._label) {
      const t = document.createElement("label");
      t.className = "label", t.textContent = this._label, m(t, "field-label"), e.appendChild(t);
    }
    if (s && s !== this._label) {
      const t = document.createElement("div");
      t.className = "helper", t.textContent = s, m(t, "field-helper"), e.appendChild(t);
    }
    return e;
  }
  /** 外部设置 schema/path/label/value */
  set schema(n) {
    this._schema = V(n), this.render();
  }
  get schema() {
    return this._schema;
  }
  set path(n) {
    this._path = n ?? [], this.render();
  }
  get path() {
    return this._path;
  }
  set label(n) {
    this._label = n, this.render();
  }
  get label() {
    return this._label;
  }
  set i18n(n) {
    n && (this._i18n = { ...this._i18n, ...n }), this.render();
  }
  get i18n() {
    return this._i18n;
  }
  setValue(n) {
    this._value = n, this.render();
  }
  getValue() {
    return this._value;
  }
  /** 触发变更事件（冒泡） */
  emitChange(n) {
    this._value = n, this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { path: this._path, value: n }
      })
    );
  }
}
class J extends w {
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const i = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !i)) {
        const o = this._value ?? "";
        this.$input.value !== o && document.activeElement !== this.$input && (this.$input.value = o);
        return;
      }
    }
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("string", n.description), e = document.createElement("input");
    this.$input = e, e.className = "input", m(e, "field-input", "field-input-text"), e.type = "text", e.name = k(this._path), e.id = A(this._path), n?.pattern?.source && (e.pattern = n.pattern.source), n?.max != null && (e.maxLength = n.max), e.value = this._value ?? "", e.oninput = () => this.emitChange(O("string", e.value));
    const t = s.querySelector("label.label");
    t && (t.htmlFor = e.id), s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-string", J);
class K extends w {
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const a = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !a)) {
        const c = this._value ?? "";
        this.$input.value !== String(c) && document.activeElement !== this.$input && (this.$input.value = c);
        return;
      }
    }
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = this._schema?.type ?? "number", s = L(this._schema), e = this.makeFieldContainer("number", s.description), t = document.createElement("input");
    this.$input = t, t.className = "input", m(t, "field-input", "field-input-number"), t.name = k(this._path), t.id = A(this._path), s?.min != null && (t.min = String(s.min)), s?.max != null && (t.max = String(s.max)), s?.step != null && (t.step = String(s.step)), n === "percent" && !t.step && (t.step = "0.01"), t.value = this._value ?? "", t.oninput = () => this.emitChange(O(n, t.value));
    const i = e.querySelector("label.label");
    i && (i.htmlFor = t.id), s.role === "slider" ? t.type = "range" : t.type = "number", e.appendChild(t), this.$root.appendChild(e);
  }
}
b("schema-form-number", K);
class Y extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("boolean", n.description), e = document.createElement("label");
    e.className = "checkbox", m(e, "field-checkbox");
    const t = document.createElement("input");
    t.type = "checkbox", t.checked = !!this._value, t.name = k(this._path), t.id = A(this._path), m(t, "field-input", "field-input-checkbox");
    const i = document.createElement("span");
    i.textContent = n.description ?? this._label ?? "", m(i, "field-checkbox-text"), t.onchange = () => this.emitChange(t.checked);
    const a = s.querySelector("label.label");
    a && (a.htmlFor = t.id), e.append(t, i), s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-boolean", Y);
function j(r) {
  return String(r).padStart(2, "0");
}
function P(r) {
  return `${r.getFullYear()}-${j(r.getMonth() + 1)}-${j(r.getDate())}`;
}
function H(r) {
  return `${j(r.getHours())}:${j(r.getMinutes())}`;
}
function M(r) {
  return `${P(r)}T${H(r)}`;
}
class X extends w {
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const a = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !a)) {
        const l = L(this._schema).role || "date";
        if (document.activeElement !== this.$input)
          if (this._value instanceof Date)
            l === "date" ? this.$input.value = P(this._value) : l === "time" ? this.$input.value = H(this._value) : l === "datetime" && (this.$input.value = M(this._value));
          else if (typeof this._value == "string" && l !== "time") {
            const d = new Date(this._value);
            isNaN(+d) || (l === "date" ? this.$input.value = P(d) : l === "datetime" && (this.$input.value = M(d)));
          } else this._value || (this.$input.value = "");
        return;
      }
    }
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("date", n.description), e = document.createElement("input");
    this.$input = e, e.className = "input", m(e, "field-input", "field-input-date");
    const t = n.role || "date";
    if (t === "datetime" ? e.type = "datetime-local" : t === "time" ? e.type = "time" : e.type = "date", e.name = k(this._path), e.id = A(this._path), this._value instanceof Date)
      t === "date" ? e.value = P(this._value) : t === "time" ? e.value = H(this._value) : t === "datetime" && (e.value = M(this._value));
    else if (typeof this._value == "string" && t !== "time") {
      const a = new Date(this._value);
      isNaN(+a) || (t === "date" ? e.value = P(a) : t === "datetime" && (e.value = M(a)));
    }
    e.oninput = () => {
      n.role;
      let a;
      if (!e.value)
        a = void 0;
      else {
        const o = new Date(e.value);
        a = Number.isNaN(+o) ? void 0 : o;
      }
      this.emitChange(a);
    };
    const i = s.querySelector("label.label");
    i && (i.htmlFor = e.id), s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-date", X);
class R extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this._schema.value;
    if (n.role === "raw-html") {
      if (s instanceof Node) {
        this.$root.append(s);
        return;
      } else if (typeof s == "function") {
        this.$root.append(s());
        return;
      } else if (typeof s == "string") {
        const a = document.createElement("div");
        a.innerHTML = String(s), m(a, "field-const-value"), this.$root.appendChild(a);
        return;
      }
    }
    const e = this.makeFieldContainer("const", n.description), t = document.createElement("section");
    t.className = "const content", t.textContent = String(s), t.id = A(this._path), m(t, "field-const-value");
    const i = e.querySelector("label.label");
    i && (i.htmlFor = t.id), e.appendChild(t), this.$root.appendChild(e);
  }
}
b("schema-form-const", R);
class Z extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("intersect", n.description);
    s.classList.remove("field");
    const e = document.createElement("div");
    e.classList.add("group"), m(e, "field-group");
    const t = this._schema.list || [], i = t.length > 0 && t.every((o) => o?.type === "object"), a = (o, c) => {
      if (Array.isArray(o) && Array.isArray(c)) return c.slice();
      if (o && c && typeof o == "object" && typeof c == "object") {
        const l = { ...o };
        for (const d of Object.keys(c))
          l[d] = d in l ? a(l[d], c[d]) : c[d];
        return l;
      }
      return c ?? o;
    };
    if (i) {
      const o = this._value && typeof this._value == "object" ? this._value : {};
      t.forEach((c, l) => {
        const d = c?.meta?.description ?? "", y = I(c, this._path, o, d, this._i18n);
        y.addEventListener("change", (u) => {
          u.stopPropagation();
          const h = a(this._value ?? {}, u.detail.value);
          this.emitChange(h);
        }), e.appendChild(y);
      });
    } else {
      const o = t[t.length - 1], c = I(o, this._path, this._value, this._label, this._i18n);
      c.addEventListener("change", (l) => {
        l.stopPropagation(), this.emitChange(l.detail.value);
      }), e.appendChild(c);
    }
    s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-intersect", Z);
function le(r) {
  switch (r.type) {
    case "intersect":
      return "schema-form-intersect";
    case "string":
      return "schema-form-string";
    case "number":
    case "natural":
    case "percent":
      return "schema-form-number";
    case "boolean":
      return "schema-form-boolean";
    case "date":
      return "schema-form-date";
    case "const":
      return "schema-form-const";
    case "array":
      return "schema-form-array";
    case "object":
      return "schema-form-object";
    case "tuple":
      return "schema-form-tuple";
    case "dict":
      return "schema-form-dict";
    case "union": {
      const s = r.list || [];
      return s.length === 2 && s[0]?.type === "is" && s[0]?.constructor === Date && s[1]?.type === "transform" && (s[1]?.inner?.meta?.role === "datetime" || s[1]?.inner?.meta?.role === "date" || s[1]?.inner?.meta?.role === "time") ? "schema-form-date" : "schema-form-union";
    }
    default:
      return "schema-form-string";
  }
}
function I(r, n, s, e, t) {
  const i = le(r), a = document.createElement(i);
  return a.schema = r, a.path = n, a.label = e, t && (a.i18n = t), a.setValue?.(s), a.setAttribute("exportparts", oe), a;
}
class G extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("union", n.description), e = this._schema.list || [];
    if (ce(e)) {
      const t = document.createElement("select");
      t.className = "input", m(t, "field-input", "field-input-select"), t.name = k(this._path), t.id = A(this._path), e.forEach((a) => {
        const o = document.createElement("option");
        o.value = String(a.value), o.textContent = String(a.meta?.description || a.value || a.type), this._value === a.value && (o.selected = !0), t.appendChild(o);
      }), t.onchange = () => this.emitChange(O("string", t.value));
      const i = s.querySelector("label.label");
      i && (i.htmlFor = t.id), s.appendChild(t);
    } else {
      const t = document.createElement("div");
      t.className = "toolbar", m(t, "field-toolbar");
      const i = document.createElement("select");
      i.className = "input", m(i, "field-input", "field-input-select", "field-toolbar-select"), i.name = k(this._path) + ".__type", i.id = A(this._path) + "__type";
      let a = 0;
      e.forEach((d, y) => {
        const u = document.createElement("option");
        u.value = String(y), u.textContent = String(d.meta?.description || d.value || d.type), i.appendChild(u);
      }), i.onchange = () => {
        a = Number(i.value);
        const d = e[a], y = T(d);
        this.emitChange(y), l();
      };
      const o = s.querySelector("label.label");
      o && (o.htmlFor = i.id), t.appendChild(i), s.appendChild(t);
      const c = document.createElement("div");
      c.className = "group", m(c, "field-group");
      const l = () => {
        c.innerHTML = "";
        const d = e[a], y = I(d, this._path, this._value, this._label);
        y instanceof R || (y.addEventListener("change", (u) => {
          u.stopPropagation(), this.emitChange(u.detail.value);
        }), c.appendChild(y));
      };
      l(), s.appendChild(c);
    }
    this.$root.appendChild(s);
  }
}
b("schema-form-union", G);
class Q extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("tuple", n.description), e = document.createElement("div");
    e.className = "group", m(e, "field-group");
    const t = Array.isArray(this._value) ? this._value : [];
    (this._schema.list || []).forEach((i, a) => {
      const o = I(
        i,
        [...this._path, a],
        t[a],
        `${this._label ?? ""}[${a}]`
      );
      o.addEventListener("change", (c) => {
        c.stopPropagation();
        const l = Array.isArray(this._value) ? this._value.slice() : [];
        l[a] = c.detail.value, this.emitChange(l);
      }), e.appendChild(o);
    }), s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-tuple", Q);
class W extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("object", n.description), e = document.createElement("div");
    e.className = "group", m(e, "field-group");
    const t = this._schema.dict || {};
    Object.keys(t).forEach((i) => {
      if (t[i]?.meta?.hidden) return;
      const a = (this._value ?? {})[i], o = I(t[i], [...this._path, i], a, i);
      o.addEventListener("change", (c) => {
        c.stopPropagation();
        const l = { ...this._value ?? {} };
        l[i] = c.detail.value, this.emitChange(l);
      }), e.appendChild(o);
    }), s.appendChild(e), this.$root.appendChild(s);
  }
}
b("schema-form-object", W);
class q extends w {
  constructor() {
    super(...arguments), this._itemIds = [];
  }
  static {
    this._idCounter = 0;
  }
  generateItemId() {
    try {
      if (typeof crypto < "u" && typeof crypto.randomUUID == "function")
        return crypto.randomUUID();
    } catch {
    }
    return "i" + q._idCounter++;
  }
  ensureItemIds(n) {
    for (; this._itemIds.length < n; ) this._itemIds.push(this.generateItemId());
    this._itemIds.length > n && (this._itemIds.length = n);
  }
  // 采集当前行位置信息（用于 FLIP）
  capturePositions(n) {
    const s = {};
    return n.querySelectorAll(".row").forEach((e) => {
      const t = e.dataset.uid;
      t && (s[t] = e.getBoundingClientRect());
    }), s;
  }
  playFLIP(n, s) {
    Array.from(n.querySelectorAll(".row")).forEach((t) => {
      const i = t.dataset.uid;
      if (!i) return;
      const a = s[i];
      if (!a) return;
      const o = t.getBoundingClientRect(), c = a.left - o.left, l = a.top - o.top;
      (c || l) && (t.style.transition = "none", t.style.transform = `translate(${c}px, ${l}px)`, requestAnimationFrame(() => {
        t.style.transition = "transform .25s ease", t.style.transform = "";
      }));
    });
  }
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("array", n.description), e = document.createElement("div");
    e.className = "group", m(e, "field-group");
    const t = this._schema.inner, i = () => Array.isArray(this._value) ? this._value : [];
    this.ensureItemIds(i().length);
    const a = (l, d) => {
      e.innerHTML = "", i().forEach((u, h) => {
        const p = [...this._path, h], f = document.createElement("div");
        f.className = "row schema-collection-row", m(f, "field-row", "collection-row");
        const _ = this._itemIds[h];
        f.dataset.uid = _, f.setAttribute("data-path", D(p));
        const x = I(
          t,
          p,
          u,
          `${this._label ?? ""}[${h}]`
        );
        x.addEventListener("change", ($) => {
          $.stopPropagation();
          const C = i().slice();
          C[h] = $.detail.value, this._value = C, this.emitChange(C);
        });
        const F = document.createElement("div");
        F.className = "actions", m(F, "field-actions");
        const E = document.createElement("button");
        E.type = "button", E.className = "btn", m(E, "field-button", "field-button-secondary"), E.textContent = this._i18n.arrayMoveUp ?? "↑", E.onclick = () => {
          if (h <= 0) return;
          const $ = this.capturePositions(e), C = i().slice();
          [C[h - 1], C[h]] = [C[h], C[h - 1]], [this._itemIds[h - 1], this._itemIds[h]] = [
            this._itemIds[h],
            this._itemIds[h - 1]
          ], this._value = C, a($), this.emitChange(C);
        };
        const g = document.createElement("button");
        g.type = "button", g.className = "btn", m(g, "field-button", "field-button-secondary"), g.textContent = this._i18n.arrayMoveDown ?? "↓", g.onclick = () => {
          const $ = i();
          if (h >= $.length - 1) return;
          const C = this.capturePositions(e), N = $.slice();
          [N[h + 1], N[h]] = [N[h], N[h + 1]], [this._itemIds[h + 1], this._itemIds[h]] = [
            this._itemIds[h],
            this._itemIds[h + 1]
          ], this._value = N, a(C), this.emitChange(N);
        };
        const v = document.createElement("button");
        v.type = "button", v.className = "btn danger", m(v, "field-button", "field-button-danger"), v.textContent = this._i18n.arrayRemove ?? "×", v.onclick = () => {
          f.classList.add("leaving");
          const $ = 250;
          let C = !1;
          const N = () => {
            if (C) return;
            C = !0, clearTimeout(ne);
            const B = i().filter((he, ie) => ie !== h);
            this._itemIds.splice(h, 1);
            const se = this.capturePositions(e);
            this._value = B, a(se), this.emitChange(B);
          };
          f.addEventListener("transitionend", N, { once: !0 });
          const ne = setTimeout(N, $ + 80);
        }, F.append(E, g, v), f.appendChild(x), f.appendChild(F), e.appendChild(f), d && d === _ && (f.classList.add("enter"), requestAnimationFrame(() => {
          f.classList.add("enter-active");
        }), requestAnimationFrame(() => {
          f.classList.remove("enter");
        }));
      }), l && this.playFLIP(e, l);
    };
    a();
    const o = document.createElement("button");
    o.type = "button", o.className = "btn primary", m(o, "field-button", "field-button-primary"), o.textContent = this._i18n.arrayAdd ?? "+", o.onclick = () => {
      const l = this.capturePositions(e), d = i().slice(), y = T(t);
      d.push(y);
      const u = this.generateItemId();
      this._itemIds.push(u), this._value = d, a(l, u), this.emitChange(d);
    };
    const c = document.createElement("div");
    c.className = "actions", m(c, "field-actions"), c.appendChild(o), s.appendChild(e), s.appendChild(c), this.$root.appendChild(s);
  }
}
b("schema-form-array", q);
class ee extends w {
  render() {
    this.$root.innerHTML = `<style>${S}</style>`;
    const n = L(this._schema), s = this.makeFieldContainer("dict", n.description), e = document.createElement("div");
    e.className = "group", m(e, "field-group");
    const t = this._schema.inner, i = this._value ?? {}, a = (u) => `d_${u}`, o = () => {
      const u = {};
      return e.querySelectorAll(".kv").forEach((h) => {
        const p = h.dataset.uid;
        p && (u[p] = h.getBoundingClientRect());
      }), u;
    }, c = (u) => {
      e.querySelectorAll(".kv").forEach((h) => {
        const p = h.dataset.uid;
        if (!p) return;
        const f = u[p];
        if (!f) return;
        const _ = h.getBoundingClientRect(), x = f.left - _.left, F = f.top - _.top;
        (x || F) && (h.style.transition = "none", h.style.transform = `translate(${x}px, ${F}px)`, requestAnimationFrame(() => {
          h.style.transition = "transform .25s ease", h.style.transform = "";
        }));
      });
    }, l = (u, h) => {
      e.innerHTML = "", Object.keys(i).forEach((p) => {
        const f = [...this._path, p], _ = document.createElement("div");
        _.className = "kv schema-collection-row", m(_, "field-row", "collection-row"), _.dataset.uid = a(p), _.setAttribute("data-path", D(f));
        const x = document.createElement("input");
        x.className = "input", m(x, "field-input", "field-input-text"), x.value = p, x.name = k(f) + ".__key", x.id = A(f) + "__key";
        const F = I(t, f, i[p], `${this._label ?? ""}[${p}]`), E = document.createElement("button");
        E.type = "button", E.className = "btn danger", m(E, "field-button", "field-button-danger"), E.textContent = this._i18n.dictRemove ?? "×", E.onclick = () => {
          const g = o();
          delete i[p];
          const v = { ...this._value ?? {} };
          delete v[p], this._value = v, l(g), this.emitChange(v);
        }, x.onchange = () => {
          const g = x.value.trim();
          if (!g || g === p || i[g] !== void 0) return;
          const v = o();
          i[g] = i[p], delete i[p];
          const $ = { ...this._value ?? {} };
          $[g] = $[p], delete $[p], this._value = $, l(v), this.emitChange($);
        }, F.addEventListener("change", (g) => {
          g.stopPropagation();
          const v = { ...this._value ?? {} };
          v[p] = g.detail.value, this._value = v, this.emitChange(v);
        }), _.append(x, F, E), e.appendChild(_), h === p && (_.classList.add("enter"), requestAnimationFrame(() => _.classList.add("enter-active")), requestAnimationFrame(() => _.classList.remove("enter")));
      }), u && c(u);
    };
    l();
    const d = document.createElement("button");
    d.type = "button", d.className = "btn primary", m(d, "field-button", "field-button-primary"), d.textContent = this._i18n.dictAdd ?? "+", d.onclick = () => {
      let u = Object.keys(i).length + 1, h = `k${u}`;
      for (; i[h] !== void 0; ) h = `k${++u}`;
      const p = o();
      i[h] = T(t);
      const f = { ...this._value ?? {}, [h]: i[h] };
      this._value = f, l(p, h), this.emitChange(f);
    };
    const y = document.createElement("div");
    y.className = "actions", m(y, "field-actions"), y.appendChild(d), s.appendChild(e), s.appendChild(y), this.$root.appendChild(s);
  }
}
b("schema-form-dict", ee);
class te extends HTMLElement {
  constructor() {
    super(), this._i18n = { ...z }, this._i18nCommitted = !1, this.$root = this.attachShadow({ mode: "open" });
    const n = document.createElement("style");
    n.textContent = S, this.$root.appendChild(n);
    const s = document.createElement("div");
    s.className = "wrapper", m(s, "wrapper");
    const e = document.createElement("form");
    e.className = "form", m(e, "form"), s.appendChild(e), this.$root.appendChild(s), this.addEventListener("change", (t) => {
      if (!t?.detail) return;
      const { path: i, value: a } = t.detail;
      Array.isArray(i) && i.length === 0 ? this._state = a : ae(this._state ?? (this._state = {}), i, a), this.dispatchEvent(
        new CustomEvent("form-change", { detail: { path: i, value: a, state: this._state } })
      );
    });
  }
  // --- 对外 API ---
  set schema(n) {
    this._schema = V(n);
    try {
      this._state = this._schema(null, { autofix: !0 });
    } catch {
      this._state = T(this._schema);
    }
    this.render();
  }
  get schema() {
    return this._schema;
  }
  set schemaJSON(n) {
    this.schema = n;
  }
  get schemaJSON() {
    return this._schema?.toJSON?.();
  }
  setData(n, s = { validate: !0, autofix: !0 }) {
    if (!this._schema) throw new Error("请先设置 schema");
    const e = s.validate ? this._schema(n ?? null, { autofix: s.autofix }) : n;
    this._state = e, this.render();
  }
  getData(n = { validate: !0, autofix: !0 }) {
    if (!this._schema) throw new Error("请先设置 schema");
    const s = this._state;
    return n.validate ? this._schema(s ?? null, { autofix: n.autofix }) : s;
  }
  reset() {
    try {
      this._state = this._schema(null, { autofix: !0 });
    } catch {
      this._state = T(this._schema);
    }
    this.render();
  }
  refresh() {
    this.render();
  }
  // i18n 相关
  set i18n(n) {
    this._i18nCommitted || (this._i18n = { ...this._i18n, ...n }, this._i18nCommitted = !0, this.render());
  }
  get i18n() {
    return this._i18n;
  }
  render() {
    if (!this._schema) return;
    const n = this.$root.querySelector("form");
    n.innerHTML = "";
    const s = I(
      this._schema,
      [],
      this._state,
      this._i18n.rootLabel,
      this._i18n
    );
    n.appendChild(s);
  }
}
b("schema-form", te);
function de(r, n) {
  const s = document.createElement("schema-form");
  s.schema = r, n?.i18n && (s.i18n = n.i18n), n?.value && s.setData(n.value);
  const e = n?.onChange, t = () => {
    try {
      e?.(s.getData());
    } catch {
    }
  };
  return e && s.addEventListener("form-change", t), {
    el: s,
    mount: (i) => {
      if (typeof i == "string") {
        const a = document.querySelector(i);
        if (!a) throw new Error("未找到挂载节点：" + i);
        a.innerHTML = "", a.appendChild(s);
      }
      if (i instanceof HTMLElement)
        i.innerHTML = "", i.appendChild(s);
      else
        throw new Error("挂载节点必须是 HTMLElement 或 选择器字符串");
      return s;
    },
    setData: (i, a) => s.setData(i, a),
    getData: (i) => s.getData(i),
    destroy: () => {
      e && s.removeEventListener("form-change", t), s.remove();
    }
  };
}
function me() {
  b("schema-form", te), b("schema-form-string", J), b("schema-form-number", K), b("schema-form-boolean", Y), b("schema-form-date", X), b("schema-form-const", R), b("schema-form-union", G), b("schema-form-tuple", Q), b("schema-form-object", W), b("schema-form-array", q), b("schema-form-dict", ee), b("schema-form-intersect", Z);
}
export {
  z as DEFAULT_I18N,
  te as SchemaForm,
  de as createSchemasteryForm,
  me as install
};
//# sourceMappingURL=index.js.map
